import '../css/Circle.css'
import '../css/Heading.css'


export const Heading = () => {

    return (

        <div className="heading">
            <h1>
                <div className="heading__light">See any transcript's</div>
                <div className="heading__medium">emotional landscape</div>
            </h1>
        </div>
  
    )
}